export enum ContactUsTopicEnum {
    TECHNICAL_ISSUES =1,
    FEATURE_SUGGESTIONS = 2,
    GENERAL_INQUIRIES = 3,
    REPORT_ABUSE = 4,
    ACCOUNT_ISSUES = 5,
    MARKETING_PARTNERSHIPS = 6,
    OTHER = 7,
  }


  
  export const  ContactUsTopicList=[
      {value:ContactUsTopicEnum.TECHNICAL_ISSUES,label:'Technical Issues'},
      {value:ContactUsTopicEnum.FEATURE_SUGGESTIONS,label:'Feature Suggestions'},
      {value:ContactUsTopicEnum.GENERAL_INQUIRIES,label:'General Inquiries'},
      {value:ContactUsTopicEnum.REPORT_ABUSE,label:'Report Abuse'},
      {value:ContactUsTopicEnum.ACCOUNT_ISSUES,label:'Account Issues'},
      {value:ContactUsTopicEnum.MARKETING_PARTNERSHIPS,label:'Marketing & Partnerships'},
      {value:ContactUsTopicEnum.OTHER,label:'Other'},
  
  ]